import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TranslateService } from '../../../services/translate.service';

@Component({
  selector: 'app-follow-checkbox',
  templateUrl: './follow-checkbox.component.html',
  styleUrls: ['./follow-checkbox.component.scss'],
})
export class FollowCheckboxComponent {
  @Input()
  public fc: UntypedFormControl;

  @Input()
  public entityName: string;

  get title(): string {
    return `${TranslateService.translate(
      this.fc.value ? 'follow-checkbox-unfollow' : 'follow-checkbox-follow'
    )} ${this.entityName}`;
  }
}
